import React, { FC } from 'react';

import clsx from 'clsx';

import { CategoriesTree } from '@domains/categories';

import { CategoryAccordion } from '@components/catalog/CategoryAccordion/CategoryAccordion';
import { CategoryFilters } from '@components/catalog/CategoryFilters/CategoryFilters';

import styles from './CategorySidebar.module.scss';

export type CategorySidebarProps = {
    categoriesTree: CategoriesTree;
    className?: string;
};

export const CategorySidebar: FC<CategorySidebarProps> = (props) => {
    const { categoriesTree, className } = props;

    const hasCategoriesAccordion = categoriesTree.length > 0;

    return (
        <div className={clsx(styles.root, className)}>
            {hasCategoriesAccordion && <CategoryAccordion categoriesTree={categoriesTree} />}
            <CategoryFilters
                className={clsx(styles.filters, hasCategoriesAccordion && styles.hasTopMargin)}
            />
        </div>
    );
};
